import React from 'react'
import type { ProductSelectListProviderProps } from './Context'
import { ProductSelectListProvider } from './Context'
import { Layout } from './Layout'

export const ProductSelectList = (props: Omit<ProductSelectListProviderProps, 'children'>) => {
  return (
    <ProductSelectListProvider {...props}>
      <Layout />
    </ProductSelectListProvider>
  )
}
